import GigCards from './mp_gig_card';
import GigCard from './mp_gig_card/GigCard.js';
import ListView from './list_view_card';
import ListViewItem from './list_view_card/ListView';
import { env } from '@fiverr-private/futile';

if (env.browser) {
    Object.assign(window, { ListViewCard: ListView, BuyerGigCard: GigCards });
}

export default GigCards;
export { GigCards, GigCard, ListView, ListViewItem };



// WEBPACK FOOTER //
// ./src/index.js